// eslint-disable-next-line no-unused-vars
/*global FB*/

import Echo from 'laravel-echo'
import { navigatorDevice } from '../../events-webview'

export const setEcho = data => {
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: window.APP_CONFIG.REACT_APP_PUSHER_KEY,
        authEndpoint: `${window.APP_CONFIG.REACT_APP_API_URL}api/broadcasting/auth`,
        cluster: 'eu',
        encrypted: true,
        auth: { headers: {
            Authorization: `Bearer ${(data || {}).access_token}`,
            Accept: 'application/json',
        } },
    })

    return new Promise(resolve => resolve())
}

/**
 * Returns url query parameter.
 * USAGE: getUrlParameter('lorem')
 *
 * @param {string} name
 * @param props - additional search in location props?
 * @returns {*}
 */
export const getUrlParameter = (name, props = null) => {
    if (props && props.match.location && props.match.location.query) {
        return props.match.location.query[name] || null
    }
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
    let results = regex.exec(window.location.search)
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

/**
 * Cheeck if url is web viewed
 *
 * @returns {boolean}
 */
export const isWebView = () => navigatorDevice !== false || getUrlParameter('webview') === 'true'

/**
 * @param {...string} queryNames
 */
export const removeQuery = (...queryNames) => {
    // const location = Object.assign({}, queryString.parse(this.props.history.location.search))
    // queryNames.forEach(q => delete location.query[q])
    // this.props.history.push(location)
}
